module.exports = __webpack_public_path__ + "img/hidden03.40618fe1.jpg";